import * as React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {ListPageRoute} from '../../email-marketing/routes/list-page-route';
import {PageRoute} from '../../email-marketing/routes/page-route';
import {RestrictedListPageRoute} from '../../email-marketing/routes/restricted-list-page-route';
import {RestrictedPageRoute} from '../../email-marketing/routes/restricted-page-route';
import {RestrictedRoute} from '../../email-marketing/routes/restricted-route';
import {CalendarPage} from '../../setup/calendar/calendar-page';

import {SCHEDULER_VIEW_SEARCH, SCHEDULER_MANAGED_VIEW_SEARCH} from '../helpers';
import {ManagedMeetingsListPage} from '../managed-meetings/managed-meetings-list-page';
import {MeetingPageWrapper} from '../meeting-page-wrapper';
import {MeetingPreview} from '../meeting-preview';
import {MeetingsListPage} from '../meetings-list-page';

/**
 * Routes for  Scheduler pages that are accessible in the main app, or when embedded.
 *
 * @returns {JSX.Element}
 * @constructor
 */
export const SchedulerRoutes = () => {
    const {user} = useGetSessionUser();
    const canAccessManagedMeetings = user ? user.permissions.canAccessSetup : true; // True while loading, otherwise the user is booted from the page while reloading

    return (
        <Switch>
            <PageRoute
                // @ts-expect-error
                exact={true}
                path='/sales/scheduler/calendar-settings'
                component={CalendarPage}
            />
            <RestrictedListPageRoute
                // @ts-expect-error
                exact={true}
                path='/sales/scheduler/managed'
                component={ManagedMeetingsListPage}
                defaultQuery={'?filter%5Barchived%5D=false'}
                localStorageKey={SCHEDULER_MANAGED_VIEW_SEARCH}
                hasAccess={canAccessManagedMeetings}
                redirectPath='/sales/scheduler'
            />
            <RestrictedRoute
                path='/sales/scheduler/managed/:meetingId/meeting-preview'
                exact={true}
                render={(routeProps) => {
                    const meetingId: string = routeProps.match.params.meetingId as any;

                    return <MeetingPreview meetingId={meetingId} />;
                }}
                hasAccess={canAccessManagedMeetings}
                redirectPath='/sales/scheduler'
            />
            <Redirect
                exact={true}
                from='/sales/scheduler/managed/:meetingId'
                to='/sales/scheduler/managed/:meetingId/details'
            />
            <RestrictedPageRoute
                // @ts-expect-error
                exact={true}
                path='/sales/scheduler/managed/:meetingId/:tab'
                reportKey='scheduler'
                initialFilterKey='meetings'
                idParam='meetingId'
                component={MeetingPageWrapper}
                hasAccess={canAccessManagedMeetings}
                redirectPath='/sales/scheduler'
            />
            <ListPageRoute
                // @ts-expect-error
                exact={true}
                path='/sales/scheduler'
                localStorageKey={SCHEDULER_VIEW_SEARCH}
                defaultQuery={
                    // Default view is user's own meetings
                    user && user.permissions.canViewAllMeetings
                        ? `?view=board&sort=-modifiedTime&filter%5Bhost%5D%5BanyAll%5D=any&filter%5Bhost%5D%5Bdata%5D%5B0%5D%5Bdata%5D=${user.id}`
                        : '?view=board&sort=-modifiedTime'
                }
                ignoreUnknownParams={true}
                component={MeetingsListPage}
                includeHash={true}
            />
            <Route
                path='/sales/scheduler/:meetingId/meeting-preview'
                exact={true}
                render={(routeProps) => {
                    const meetingId: string = routeProps.match.params.meetingId as any;

                    return <MeetingPreview meetingId={meetingId} />;
                }}
            />
            <Redirect
                exact={true}
                from='/sales/scheduler/:meetingId'
                to='/sales/scheduler/:meetingId/details'
            />
            <PageRoute
                // @ts-expect-error
                exact={true}
                path='/sales/scheduler/:meetingId/:tab'
                reportKey='scheduler'
                initialFilterKey='meetings'
                idParam='meetingId'
                component={MeetingPageWrapper}
            />
            <Redirect exact={true} from='/scheduler' to='/sales/scheduler' />
        </Switch>
    );
};
